<template>
  <a
    @click="addClick(id)"
    v-ripple
    :href="link"
    :target="target ? '_blank' : '_self'"
    class="item d-flex justify-center align-center"
    :class="config.btn_bg_color ? 'custom-btn-bg--color' : 'btn-outlined'"
  >
    <div class="d-flex px-10 custom-btn-text--color">
      <span class="text-center">
        <v-icon v-if="icon" color="custom-icon-color" size="23" class="mr-2">
          {{ icon }}
        </v-icon>
        <span class="font-weight-black font-lufga btn-bg--color-alt">
          {{ title }}
        </span>
      </span>
      <v-btn
        v-if="validateUrl(link)"
        @click.prevent="shareLink(link)"
        class="item-share d-flex align-center justify-center pa-5"
        target="_self"
        icon
      >
        <v-icon color="custom-icon-color" size="18">fas fa-share-alt</v-icon>
      </v-btn>
    </div>
  </a>
</template>

<script>
import { validateUrl } from "../../utils/validateUrl";
import axios from "axios";

export default {
  props: {
    id: Number,
    title: {
      type: String,
      default: "",
    },
    link: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "",
    },
    target: {
      type: Number,
      default: 0,
    },
    config: {
      type: Object,
    },
  },
  methods: {
    validateUrl,
    shareLink(link) {
      if (navigator.share) {
        navigator.share({
          url: link,
        });
      }
    },
    addClick(id) {
      const urlClick = `${this.server}/post/links/${id}`;
      const urlHit = `${this.server}/post/hits/${id}`;

      const handleError = (error) => {
        console.error(error);
      };

      Promise.all([axios.post(urlClick), axios.post(urlHit)]).catch(
        handleError
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  z-index: 1 !important;
  position: relative;
  height: 55px;
  text-decoration: none;
  border-radius: 36px;
  font-size: 18px !important;
  @media (max-width: 960px) {
    font-size: 16px !important;
  }
  @media (max-width: 600px) {
    font-size: 12px !important;
  }
  &:hover .item-share {
    opacity: 1;
  }
  &-share {
    z-index: 10 !important;
    opacity: 0;
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    transition: all 0.15s ease;
    @media (max-width: 600px) {
      right: 5px;
    }
  }
}
</style>
